module.exports = __webpack_public_path__ + "img/Knacker_grillen.1fa05f60.jpg";